module.exports = __webpack_public_path__ + "static/steps-path-2-cb724aaa35899b4a3a54c94960b83d39.jpg";